import React, { useState } from 'react';
import axios from '../../../plugins/axios';
import { phone } from '../../../constants/mask';

// components
import Form from '../../../components/Form/Form';
import Alert from '../../../components/Alert/Alert';

// icons
import phoneIcon from '../../../brand/generated/input/phone.svg';
import HookForm from '../../../components/HookForm/HookForm';
import Input from '../../../components/Inputs/Input/Input';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import Select from '../../../components/Inputs/Select/Select';
import SelectMarks from '../../../components/Selects/SelectMarks';
import SelectModels from '../../../components/Selects/SelectModels';
import SelectStatuses from '../../../components/Selects/SelectStatuses';
import SelectSources from '../../../components/Selects/SelectSources';
import alert from '../../../helpers/alert';

const actions = [{ type: 'button', action: 'Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ' }];
const formStyles = {
  leadInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'b b b b'` },
  other: { display: 'grid' },
  actions: { display: 'grid', gap: '20px', gridTemplateColumns: 'auto auto auto auto auto', marginBottom: '0' },
};

const LeadCreate = () => {
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [leadInfo, setLeadInfo] = useState([
    { type: 'date', value: new Date(), name: 'created_at', label: 'ÐÐ°ÑÐ°', component: Datepicker },
    { type: 'input', name: 'fio', label: 'ÐÐ¼Ñ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¸Ð¼Ñ' },
    {
      name: 'sourceId',
      label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      component: SelectSources,
    },
    {
      type: 'input',
      name: 'phone',
      label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
      placeholder: '+7(___) ___-__-__',
      icon: phoneIcon,
      mask: phone,
    },
    { type: 'input', name: 'email', label: 'Email', placeholder: 'example@gmail.com' },
    { type: 'selectMarks', name: 'mark', component: SelectMarks },
    {
      type: 'selectModels',
      name: 'model',
      dependency: 'mark',
      dependencyAccessor: (obj) => obj?.value,
      component: SelectModels,
    },
    {
      type: 'select',
      label: 'Ð¡ÑÐ°ÑÑÑ',
      name: 'statusId',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      component: SelectStatuses,
    },
  ]);

  const [leadId, setLeadId] = React.useState(null);

  const handleSubmit = (data) => {
    axios
      .post('/api/crm/leads/createLead', {
        ...data,
        markId: data?.mark?.value,
        modelId: data?.model?.value,
        sourceId: data?.sourceId?.value,
        statusId: data?.statusId?.value,
      })
      .then((res) => {
        setLeadId(res.data);
        setSucces({ message: 'ÐÐ¸Ð´ ÑÐ¾Ð·Ð´Ð°Ð½' });
      })
      .catch((error) => {
        alert.error(JSON.stringify(error.response.data))
      });
  };

  const [other, setOther] = useState([
    {
      type: 'input',
      value: null,
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð»Ð¸Ð´Ðµ',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¾ Ð»Ð¸Ð´Ðµ',
    },
  ]);

  const addLeadComment = () => {
    axios
      .post('/api/crm/leads/addLeadComment', { comment: other[0].value, leadId: leadId })
      .then((res) => {})
      .catch((error) => {});
  };

  return (
    <>
      <HookForm
        inputs={leadInfo}
        handlerSetState={setLeadInfo}
        title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð»Ð¸Ð´Ðµ'}
        grid={formStyles.leadInfo}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð»Ð¸Ð´Ðµ'}
        onSubmit={handleSubmit}
        border
      />
      {leadId != null && (
        <Form
          inputs={other}
          title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'}
          grid={formStyles.other}
          handleSubmit={addLeadComment}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
          border
        />
      )}
      <Form inputs={actions} title={'ÐÐµÐ¹ÑÑÐ²Ð¸Ñ'} grid={formStyles.actions} border />
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} onClick={setSucces} />}
    </>
  );
};

export default LeadCreate;
